import {TEMPLATE_ID_HEADER, BOT_HEADER} from './../../utils/constants';

export const ASPECT_RATIO = '16x9';
export const BASE_CLASS = 'DestinationRefinements';

export const buildImageUrl = (template) =>
    template.replace('${templateId}', 'hw6');

export const fetchDestinationRefinementsData = (props) => {
    const {
        basePathPrefix,
        lbsId,
        template,
        isBot,
        isShowBrandHeadings,
        preposition,
    } = props;

    const params = new URLSearchParams({
        lbsId,
        isShowBrandHeadings,
        ...(preposition ? {preposition: encodeURIComponent(preposition)} : {}),
    });

    const url = `${basePathPrefix}/api/dynamic-refinements?${params}`;

    const options = {
        credentials: 'same-origin',
        headers: {[TEMPLATE_ID_HEADER]: template, [BOT_HEADER]: isBot},
    };

    return fetch(url, options)
        .then((res) => res.json())
        .catch((error) => {
            throw new Error(
                `Could not retrieve the destination refinements data: ${error.stack}`
            );
        });
};
